export default __webpack_public_path__ + "static/media/Feedback-icon.6aff4c9b.svg";